import React from 'react';
import { IoStar } from 'react-icons/io5';

interface IRatingStar {
    rating: number;
}
export const formatRating = (value?: number) => {
    return (value ?? 0).toLocaleString('de-DE', {
        maximumFractionDigits: 2,
    });
};
export const RatingStar = ({ rating }: IRatingStar) => {
    return (
        <span className="rating">
            {formatRating(rating ?? 0)}
            <IoStar className="text-primary ml-1" />
        </span>
    );
};
